module.exports = __webpack_public_path__ + "static/media/unb.8a2801ea.svg";